import React, { FunctionComponent, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDebounce } from '../../hooks/Debounce'
import { HostData } from '../Customer/Data'

interface Props {
  hosts: HostData[]
}

export function filterAndSortHosts(hosts: HostData[], term: string): HostData[] {
  const t = term.trim().toLowerCase()
  return (t ? hosts.filter(h => h.name.toLowerCase().includes(t)) : hosts)
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name))
}

export const IntelligenceHub: FunctionComponent<Props> = props => {
  const hosts = props.hosts || []
  const [searchFilter, setSearchFilter] = useState('')
  const debouncedFilter = useDebounce(searchFilter, 500)

  const term = debouncedFilter.trim().toLowerCase()
  const filteredHosts = filterAndSortHosts(hosts, debouncedFilter)

  return (
    <div className='tab' id='tab-intelligence-hub'>
      <header>
        <div className='auto'>
          <h2>Intelligence Hub</h2>
        </div>
      </header>

      <div className='auto rowview'>
        <div className='flex flex-start btm'>
          <div className='search'>
            <input
              type='search'
              placeholder='Search by name'
              size={15}
              value={searchFilter}
              onChange={e => setSearchFilter(e.target.value)}
            />
          </div>
        </div>

        <div className='list'>
          <header>
            <div className='flex flex-nowrap'>
              <div className='col customer-name'>Name</div>
            </div>
          </header>

          {filteredHosts.length === 0 && (
            <div className='empty padded'>{term ? 'No matching customers found.' : 'No customers yet.'}</div>
          )}

          <ul>
            {filteredHosts.map(h => (
              <li key={h.id}>
                <Link to={`/intelligence-hub/${h.id}`} className='flex flex-nowrap'>
                  <div className='col customer-name'>{h.name}</div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
